@import 'src/styles/variabels';
@import 'src/styles/mobile';

.root {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.close {
  flex-grow: 0;
  margin: -1rem -1rem -1rem 0;
  color: rgba($color-secondary, 0.5);
}

// N1 (brief pattern E): below md the heading takes the screen's gutter (the
// theme's dialog padding); the close's glyph sits on it, its 40 px box laid
// over the padding. Longhand: postcss-rtl prefixes a margin shorthand.
@media (max-width: map-get($breakpoints, 'md') - 1 + px) {
  .close {
    margin-right: -$mobile-space-s;
  }
}
